import { ErrorMessage, Field, FieldArray, getIn } from "formik";
import _ from "lodash";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

function DeliveryNoteDocumentationForm({ field, template, setFieldValue, values = [], errors = [] }) {
  const { t } = useTranslation();
  return (
    <div>
      <FieldArray
        name={field}
        render={(arrayHelpersDocs) => (
          <div className="row gx-0 align-items-center">
            <div className="col">
              <div className="card border-0 mb-4">
                <div className="card-body">
                  {values.map((row, row_index) => (
                    <Fragment key={`${row.id}-row-${row_index}`}>
                      <div className="row">
                        <small className="text-end d-lg-none">
                          {t("common.position")} {row_index + 1}
                        </small>
                        {row.map((col, col_index) => (
                          <Fragment key={`${row.id}-col-${col_index}`}>
                            <div
                              className={`${_.isEqual(col.type, "checkbox") ? "col-1" : "col-12 col-lg"}`}
                              key={`${col.id}-${col_index}`}
                            >
                              <label
                                className={`form-label ${row_index > 0 ? "d-lg-none" : ""}`}
                                htmlFor={`${field}[${row_index}][${col_index}].value[0]`}
                              >
                                {col.name}
                              </label>
                              {col.type !== "select" || col.isNewChoice ? (
                                <Fragment>
                                  <div className={`${_.isEqual(col.type, "checkbox") ? "form-check-input" : ""}`}>
                                    <div className="input-group mb-1">
                                      <Field
                                        name={`${field}[${row_index}][${col_index}].value[0]`}
                                        type={col.type}
                                        className={`${
                                          _.isEqual(col.type, "checkbox") ? "form-check-input" : "form-control"
                                        } ${col?.highlightBg && "bg-yellow-100 bg-opacity-25"} ${
                                          getIn(errors, field) ? "is-invalid" : ""
                                        }`}
                                      />
                                      <button
                                        type="button"
                                        className="btn btn-default d-lg-none"
                                        onClick={() => {
                                          setFieldValue(`${field}[${row_index}][${col_index}].value[0]`, "");
                                        }}
                                      >
                                        <i className="fa fa-eraser" />
                                      </button>
                                    </div>
                                  </div>
                                </Fragment>
                              ) : (
                                <div className="input-group">
                                  <Field
                                    as={"select"}
                                    name={`${field}[${row_index}][${col_index}].value[0]`}
                                    className={`form-select ${row?.highlightBg ? "bg-yellow-100 bg-opacity-25" : ""} ${
                                      getIn(errors, `${field}.${row_index}.data.values[0]`) ? "is-invalid" : ""
                                    }`}
                                    placeholder={t("items.amount")}
                                  >
                                    {col.choices.map((choice, i) => (
                                      <option key={choice} value={choice}>
                                        {choice}
                                      </option>
                                    ))}
                                  </Field>
                                  {false && (
                                    <button
                                      type="button"
                                      className="btn btn-success"
                                      onClick={() => {
                                        //setSelectedAttributeId(attr.id)
                                        setFieldValue(`documentation.${row_index}.isNewChoice`, true);
                                        setFieldValue(
                                          `documentation.${row_index}._tmp.original.values`,
                                          "TODO",
                                          //values.item_groups[
                                          //    group_index
                                          //    ].items[item_index]
                                          //    .attributes[
                                          //    attr_index
                                          //    ].data.values,
                                        );
                                        setFieldValue(field, "");
                                      }}
                                    >
                                      <span className="fa fa-plus"></span>
                                    </button>
                                  )}
                                </div>
                              )}

                              <ErrorMessage
                                name={field}
                                render={(error) => <div className="invalid-feedback">{t(error)}</div>}
                              />
                            </div>
                          </Fragment>
                        ))}
                        <div className="col-12 col-lg-auto mt-2 mt-lg-0">
                          <label className={`form-label d-none ${row_index > 0 ? "d-lg-none" : "d-lg-block"}`}>
                            {t("menu.actions")}
                          </label>
                          <div className="btn-group w-100">
                            <button
                              type="button"
                              onClick={() => {
                                arrayHelpersDocs.insert(
                                  row_index + 1,
                                  row.map((c) => ({
                                    ...c,
                                    highlightBg: false,
                                  })),
                                );
                              }}
                              className="btn btn-success"
                            >
                              <i className="fa fa-plus" />{" "}
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setFieldValue(`${field}.${row_index}`, ...template);
                              }}
                              className="btn btn-warning"
                            >
                              <i className="fa fa-eraser" />{" "}
                            </button>
                            <button
                              type="button"
                              onClick={() => arrayHelpersDocs.remove(row_index)}
                              className="btn btn-danger"
                              disabled={values.length === 1}
                            >
                              <i className="fa fa-minus" />{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                      <hr className="my-4 text-dark d-lg-none" />
                    </Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      />
    </div>
  );
}

export default DeliveryNoteDocumentationForm;
